import { render } from "./Desktop.vue?vue&type=template&id=48a96679&scoped=true&ts=true"
import script from "./Desktop.vue?vue&type=script&lang=ts"
export * from "./Desktop.vue?vue&type=script&lang=ts"

import "./Desktop.vue?vue&type=style&index=0&id=48a96679&lang=scss&scoped=true"

import exportComponent from "/Users/suhwanlim/Projects/pr/WorkoutHistory-Web/workout-history-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a96679"]])

export default __exports__